// extracted by mini-css-extract-plugin
export default {"container":"surtitle_container__1mmrS","link":"surtitle_link__1va8s"};